import { useEffect, useState } from "react";

type VersionResponse = { version?: string };

const checkForUpdate = async (): Promise<boolean> => {
    try {
        const res = await fetch(`${__BASE_PATH__}version.json?_=${Date.now()}`, {
            cache: "no-store",
        });
        if (!res.ok) {
            return false;
        }
        const data: VersionResponse = await res.json();
        return Boolean(data.version) && data.version !== __APP_VERSION__;
    } catch {
        return false;
    }
};

// Chỉ kiểm tra version mới khi người dùng quay lại tab (không polling nền liên tục).
export function useVersionCheck() {
    const [hasUpdate, setHasUpdate] = useState(false);

    useEffect(() => {
        if (import.meta.env.DEV) {
            return;
        }

        const handleVisible = () => {
            if (document.visibilityState !== "visible" || hasUpdate) {
                return;
            }
            checkForUpdate().then((outdated) => {
                if (outdated) {
                    setHasUpdate(true);
                }
            });
        };

        document.addEventListener("visibilitychange", handleVisible);
        window.addEventListener("focus", handleVisible);

        return () => {
            document.removeEventListener("visibilitychange", handleVisible);
            window.removeEventListener("focus", handleVisible);
        };
    }, [hasUpdate]);

    const applyUpdate = () => {
        const url = new URL(window.location.href);
        url.searchParams.set("_v", String(Date.now()));
        window.location.href = url.toString();
    };

    return { hasUpdate, applyUpdate };
}
